import { render } from "./PieDePagina.vue?vue&type=template&id=61b82cd1&scoped=true"
import script from "./PieDePagina.vue?vue&type=script&lang=js"
export * from "./PieDePagina.vue?vue&type=script&lang=js"

import "./PieDePagina.vue?vue&type=style&index=0&id=61b82cd1&scoped=true&lang=css"

import exportComponent from "/home/raulgarcia/Escritorio/projects/Vue/capwashmx/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61b82cd1"]])

export default __exports__